import Offer from "domain/offer";
import { OfferTypeEnum } from "domain/offerType";
import { HedgingSettings } from "./hedgingSettings";

export function findHedgeSetting(hedgingSettings: HedgingSettings[], offer: NullishPartial<Offer>): HedgingSettings {
    const offerType = offer.type === OfferTypeEnum.FixFuturesOnBasis
        ? OfferTypeEnum.Cash
        : offer.type;

    const hedgingSetting = hedgingSettings?.find(hs =>
        ((offer.location == null && hs.locationId == null) || (offer.location?.id === hs.locationId)) &&
        hs.commodityId === (offer.commodity ?? offer.deliveryPeriod?.commodity)?.id &&
        hs.offerTypeId === offerType);

    return hedgingSetting;
}

// AUT-6130: every commodity gets a Determine Later row from the start, so a row on its own doesn't mean the
// merchant set anything up - without an FCM account there's nothing to place the hedge with
export function findConfiguredHedgeSetting(hedgingSettings: HedgingSettings[], offer: NullishPartial<Offer>): HedgingSettings {
    const hedgingSetting = findHedgeSetting(hedgingSettings, offer);
    if (hedgingSetting == null) return null;

    const hasFcmAccount = hedgingSetting.fcmAccountId != null || hedgingSetting.useFcmAccountFromPosition
        || hedgingSetting.miniContractFcmAccountId != null || hedgingSetting.useMiniFcmAccountFromPosition;

    return hasFcmAccount ? hedgingSetting : null;
}